import React from 'react'

export const NothingSelected = () => {
    return (
        <div className="nothing__main-content">
            <p>Seleccióna alguna nota para visualizarla</p>
            <i className="far fa-sticky-note fa-8x" />
        </div>
    )
}
